import React from 'react';
import { Users, BookOpen, Cpu, Star } from 'lucide-react';
export function StatsBar() {
  const stats = [{
    icon: <Users className="w-5 h-5 text-cyan-400" data-id="element-246" />,
    text: '+500 personas ya lo tienen'
  }, {
    icon: <BookOpen className="w-5 h-5 text-purple-400" data-id="element-247" />,
    text: '6 volúmenes listos'
  }, {
    icon: <Cpu className="w-5 h-5 text-orange-400" data-id="element-248" />,
    text: '3 IAs dominadas'
  }, {
    icon: <Star className="w-5 h-5 text-yellow-400" data-id="element-249" />,
    text: '4.9/5 calificación ⭐'
  }];
  return <div className="border-y border-white/10 bg-white/5 backdrop-blur-sm py-6 relative z-20" data-id="element-250">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-251">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-252">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center justify-center text-center gap-2" data-id="element-253">
              {stat.icon}
              <span className="text-sm md:text-base font-medium text-gray-300" data-id="element-254">
                {stat.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}